//--------------------------------HEADER-------------------------------------
export const headerHandler = () => {
    $('.menu-item>a').on('click', function(e){
		if($(this).attr('href') === "#" || $(this).attr('href') === ""){
			e.preventDefault();
		}
		$(this).siblings('ul').toggleClass('show');
		$(this).parents('ul').find('.menu-item>ul.show').not($(this).siblings('ul')).removeClass('show');
		
		$(this).toggleClass('active');
		$(this).parents('ul').find('.menu-item>a').not(this).removeClass('active');
	});
	$('.lang-button').on('click', function(e){
		$(this).siblings('ul').toggleClass('show');
	});

	function showMenuOnHover(){
		$('.menu-primary>.menu-item').on('mouseenter', function(e){
			if($(e.target).attr('href') === '#'){
				if($('.menu-primary>.menu-item>.nav__sub.show').length > 0){
					if(!$(this).find('.nav__sub').hasClass('show')){
						$(this).find('.nav__sub').addClass('show');
						$(this).parents('.menu-primary').find('.menu-item>.nav__sub.show').not($(this).find('.nav__sub')).removeClass('show');
						
						$(this).parents('.menu-primary').find('.menu-item>a').removeClass('active');
						$(this).find('a').addClass('active');
					}
				}
			}
		});
	}
	let screenWidth = $(window).width();
	if(screenWidth > 991) {
		showMenuOnHover();
	}

	//------------BODY-CLASS-CHANGE-FOR-HEADE-MENU-----------
	$('.app-nav-toggle').on('click', function(){
		$('body').toggleClass('menu-open');
	});
	//---------------------MISSCKICK-HANDLERS-------------
	const headerSelectors = {
		btn:'.menu-item>a[href="#"]', 
		menu: '.menu-item>ul', 
		menuActive: 'show',
		btnActive: 'active'
	}
	const languageMenu = {
		btn:'.lang-button', 
		menu: '.lang-menu', 
		menuActive: 'show',
		btnActive: ''
	}
	const sidebarHeader = {
		btn:'.app-nav-toggle', 
		menu: 'header', 
		menuActive: 'menu-open',
		body: 'body'
	}

	$(document).mouseup(function (e){
        missClickHandler(headerSelectors, e);
		missClickHandler(languageMenu, e);
		missClickSidebarHandler(sidebarHeader, e);
    });
    
    function missClickHandler(refs, event){
        const { btn, menu, menuActive, btnActive} =  refs;
        const div = $(btn); 
        if (!div.is(event.target) && $(menu).has(event.target).length === 0) {
            $(menu).removeClass(menuActive);
            div.removeClass(btnActive);
        }
    }
    function missClickSidebarHandler(refs, event){
        const { btn, menu, menuActive, body} =  refs;
        const div = $(btn); 
        if (!div.is(event.target) && $(menu).has(event.target).length === 0 ) {
            $(body).removeClass(menuActive);
        }
    }
};